import type { ReactNode } from "react";
import { AddressAutocompleteInput } from "@/components/common/AddressAutocompleteInput";
import type { DocumentContactFields } from "@/lib/document-builder/blocks/contactTypes";

const INPUT_CLASS =
  "mt-1 w-full rounded-lg border border-gray-200 px-2 py-1.5 text-sm dark:border-zinc-700 dark:bg-zinc-800";

type Props = {
  value: DocumentContactFields;
  onChange: (next: DocumentContactFields) => void;
  orgNamePlaceholder?: string;
  children?: ReactNode;
};

export function ContactBlockFields(props: Props) {
  const { value, onChange, orgNamePlaceholder, children } = props;

  function patch(partial: Partial<DocumentContactFields>) {
    onChange({ ...value, ...partial });
  }

  return (
    <div className="space-y-2">
      <label className="block text-xs">
        <span className="text-gray-500">Organization name override</span>
        <input
          type="text"
          value={value.org_name}
          onChange={(e) => patch({ org_name: e.target.value })}
          placeholder={orgNamePlaceholder}
          className={INPUT_CLASS}
        />
      </label>
      <label className="block text-xs">
        <span className="text-gray-500">Contact name override</span>
        <input
          type="text"
          value={value.person_name}
          onChange={(e) => patch({ person_name: e.target.value })}
          className={INPUT_CLASS}
        />
      </label>
      <label className="block text-xs">
        <span className="text-gray-500">Phone override</span>
        <input
          type="text"
          value={value.phone}
          onChange={(e) => patch({ phone: e.target.value })}
          className={INPUT_CLASS}
        />
      </label>
      <label className="block text-xs">
        <span className="text-gray-500">Email override</span>
        <input
          type="email"
          value={value.email}
          onChange={(e) => patch({ email: e.target.value })}
          className={INPUT_CLASS}
        />
      </label>
      <label className="block text-xs">
        <span className="text-gray-500">Address override</span>
        <div className="mt-1">
          <AddressAutocompleteInput
            value={value.address}
            onChange={(next) => patch({ address: next })}
            className={INPUT_CLASS}
          />
        </div>
      </label>
      {children}
    </div>
  );
}
